import { createReducer, on } from '@ngrx/store';
import {
  initialFeedbackState,
  initialFeedbackDetailState,
  initialFeedbackCategoriesState,
  initialAddFeedbackState,
} from './feedback.state';
import {
  getFeedbacks,
  getFeedbacksSuccess,
  getFeedbacksFailure,
  updateFeedbackParams,
  getFeedbackById,
  getFeedbackByIdSuccess,
  getFeedbackByIdFailure,
  clearFeedbackDetails,
  addFeedback,
  addFeedbackSuccess,
  addFeedbackFailure,
  updateFeedback,
  updateFeedbackSuccess,
  updateFeedbackFailure,
  getFeedbackCategories,
  getFeedbackCategoriesSuccess,
  getFeedbackCategoriesFailure,
  resetAddFeedbackSuccess,
} from './feedback.action';

// List reducer
const _feedbacksReducer = createReducer(
  initialFeedbackState,
  on(getFeedbacks, (state) => ({ ...state, loading: true, error: null })),
  on(getFeedbacksSuccess, (state, { feedbacks }) => ({
    ...state,
    feedbacks,
    loading: false,
    error: null,
  })),
  on(getFeedbacksFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(updateFeedbackParams, (state, { params }) => ({
    ...state,
    params,
  })),
);

// Detail reducer
const _feedbackDetailReducer = createReducer(
  initialFeedbackDetailState,
  on(getFeedbackById, (state) => ({ ...state, loading: true, error: null })),
  on(getFeedbackByIdSuccess, (state, { feedback }) => ({
    ...state,
    feedback,
    loading: false,
    error: null,
  })),
  on(getFeedbackByIdFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(clearFeedbackDetails, () => initialFeedbackDetailState),
  on(addFeedback, (state) => ({ ...state, loading: true })),
  on(addFeedbackSuccess, (state, { feedback }) => ({
    ...state,
    feedback,
    loading: false,
  })),
  on(addFeedbackFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(updateFeedback, (state) => ({ ...state, loading: true })),
  on(updateFeedbackSuccess, (state, { feedback }) => ({
    ...state,
    feedback,
    loading: false,
  })),
  on(updateFeedbackFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

const _feedbackCategoriesReducer = createReducer(
  initialFeedbackCategoriesState,

  // Fetch
  on(getFeedbackCategories, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(getFeedbackCategoriesSuccess, (state, { categories }) => ({
    ...state,
    categories,
    loading: false,
    error: null,
  })),

  on(getFeedbackCategoriesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
);

const _addFeedbackReducer = createReducer(
  initialAddFeedbackState,

  on(addFeedback, (state) => ({
    ...state,
    loading: true,
    error: null,
    success: false,
  })),
  on(addFeedbackSuccess, (state, { feedback }) => ({
    ...state,
    loading: false,
    feedback: state.feedback || null,
    success: true,
  })),
  on(addFeedbackFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    success: false,
  })),
  on(resetAddFeedbackSuccess, (state) => ({
    ...state,
    success: false,
  })),

  on(updateFeedback, (state) => ({
    ...state,
    loading: true,
    error: null,
    success: false,
  })),
  on(updateFeedbackSuccess, (state, { feedback }) => ({
    ...state,
    loading: false,
    feedback: state.feedback || null,
    success: true,
  })),
  on(updateFeedbackFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    success: false,
  })),
);

export function feedbacksReducer(state: any, action: any) {
  return _feedbacksReducer(state, action);
}

export function feedbackDetailReducer(state: any, action: any) {
  return _feedbackDetailReducer(state, action);
}

export function feedbackCategoriesReducer(state: any, action: any) {
  return _feedbackCategoriesReducer(state, action);
}

export function addFeedbackReducer(state: any, action: any) {
  return _addFeedbackReducer(state, action);
}
